export interface StudentStory {
  id: string;
  name: string;
  age: number;
  course: string;
  quote: string;
  story: string;
  image?: string;
}

/**
 * Featured stories — currently only Pooja, who anchors the cinematic
 * quote feature at the top of the Stories section.
 */
export const featuredStories: StudentStory[] = [
  {
    id: "pooja",
    name: "Pooja Bhardwaj",
    age: 22,
    course: "Sewing & Stitching",
    quote:
      "I learned, with courage and determination, that anyone can stand on their own feet.",
    story:
      "I couldn't finish my studies, so I trained for six months with Sadafal, and after completing the course, I started working independently. Today, I run my own clothing boutique. I learned, with courage and determination, that anyone can stand on their own feet.",
    image: "/stories/pooja-portrait.jpg",
  },
];

/**
 * The wider wall of student voices — rendered text-forward in the
 * Stories section, no portraits. Each entry is a real testimonial
 * lightly edited from sadafal-education.com.
 */
export const studentVoices: StudentStory[] = [
  {
    id: "karina",
    name: "Karina",
    age: 13,
    course: "Sewing & Stitching",
    quote:
      "I am so happy to know there is still someone to help people like me.",
    story:
      "There are six members in my family. My father and mother work as labourers, and their earnings are not fixed. I wanted to learn sewing so I could help my parents. Sadafal Education understood my situation and let me study with no fees.",
  },
  {
    id: "sharad",
    name: "Sharad",
    age: 20,
    course: "Computer Skills",
    quote: "They gave me huge support to do something with my life.",
    story:
      "My father is a labourer and we always struggle with expenses for our family of six. I had to stop studying after class 12 and lost a full year. A family friend mentioned my situation to Sadafal Education, and they gave me the chance to study computers for free.",
  },
  {
    id: "kumari",
    name: "Kumari",
    age: 19,
    course: "Sewing & Stitching",
    quote: "The teachers are caring. They teach us the way my mother would.",
    story:
      "My father is a labourer in MGNREGA, the only earner for our family of seven. I had to stop studying after class 12. I wanted to learn sewing so I could start earning, and Sadafal Education waived my fees. Soon I'll be stitching clothes for others.",
  },
  {
    id: "alok",
    name: "Alok",
    age: 13,
    course: "Computer Skills",
    quote: "I love computers, and our teacher always helps me.",
    story:
      "I live in Keshripur, where my father does furniture work for our family of five. Every child here gets a computer and internet to learn on. In four months I've learned WordPad, Notepad, Word, and Excel.",
  },
  {
    id: "jyoti",
    name: "Jyoti",
    age: 18,
    course: "Computer Skills",
    quote:
      "Five months ago I knew nothing about computers. Today I've learned so much.",
    story:
      "I've been studying computer operations at Sadafal Education for five months. I had no idea how a computer worked. Now I've learned MS Office, internet basics, and fundamentals. The teachers explain things with patience until everything makes sense.",
  },
  {
    id: "neha",
    name: "Neha",
    age: 20,
    course: "Sewing & Stitching",
    quote:
      "Before I came here I didn't know how to hold scissors. Now I can stitch gowns.",
    story:
      "I'm a B.Com student who came to Sadafal to learn sewing. I knew nothing when I started, and I almost didn't enrol because I didn't even know how to hold scissors. Six months later I've learned to stitch gowns, crop tops, sararas, and palazzos.",
  },
  {
    id: "ritu",
    name: "Ritu",
    age: 17,
    course: "Computer Skills",
    quote: "After joining Sadafal Education, I got to learn so much.",
    story:
      "I had wanted to learn computers for a long time. In three months at the centre I've learned Excel, Paint, and Word, with my own computer each day. Our teachers explain things in easy language so we can grasp it all.",
  },
  {
    id: "avinash",
    name: "Avinash",
    age: 23,
    course: "Computer Operations",
    quote:
      "I want to study further, but my family's finances couldn't carry it.",
    story:
      "I'm in my B.Sc and still want to keep studying, but the finances at home make it hard. We're nine people, and my father runs a small general store. I'm learning computer operations at Sadafal Education, and the staff have been patient with my mistakes.",
  },
  {
    id: "kajal",
    name: "Kajal",
    age: 17,
    course: "Sewing & Stitching",
    quote: "Sadafal Education waived my fees so I could keep learning.",
    story:
      "I'm a class 12 student. My mother has passed away and my father is out of work. I live with my maternal grandfather, who supports five of us. I came to Sadafal to learn sewing alongside my studies, so I could look after my family. When my grandfather couldn't pay the fees, the centre waived them.",
  },
];

export interface VideoTestimonial {
  id: string;
  student: string;
  src: string;
  role: string;
  orientation: "portrait" | "landscape";
}

// fallow-ignore-next-line unused-export -- exercised directly by its unit test; no production importer yet
export const videoTestimonials: VideoTestimonial[] = [
  {
    id: "varsha",
    student: "Varsha",
    src: "/testimonials/videos/varsha_testimonial_compressed.mp4",
    role: "Intern at Agnes, Student at Varanasi",
    orientation: "portrait",
  },
  {
    id: "rebecca",
    student: "Rebecca",
    src: "/testimonials/videos/rebecca_testimonial_compressed.mp4",
    role: "Student at Kenya",
    orientation: "portrait",
  },
  {
    id: "savitha",
    student: "Savitha",
    src: "/testimonials/videos/savitha_testimonial_compressed.mp4",
    role: "Student at Varanasi",
    orientation: "landscape",
  },
  {
    id: "rose",
    student: "Rose",
    src: "/testimonials/videos/rose_testimonial_compressed.mp4",
    role: "Student at Kenya",
    orientation: "portrait",
  },
];
